import React from 'react'

const Viewallfuel = () => {
  return (
    <div className='h-screen'>Viewallfuel</div>
  )
}

export default Viewallfuel